import { routes } from "@/utils/routes";
import { useRouter } from "next/router";
import React, { useEffect } from "react";

const CareersPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.push(routes.careers);
  }, [router]);

  return <div></div>;
};

export default CareersPage;
